import { useContext } from 'react';
import { createContextHook } from '@/utils';
import { DocumentContext } from './DocumentContext';

export const useDocumentContext = createContextHook(DocumentContext);

// Non-throwing variant — returns undefined outside a provider. For code that runs
// both inside a printable document and in the plain app tree (e.g. useVibe, which
// styles the interactive layouts as well as the printable templates).
export const useDocumentContextOptional = () => useContext(DocumentContext);
